import { Fragment } from 'react';

import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Tooltip from '@mui/material/Tooltip';

import { useSidebar } from '@src/context/hooks';

const StyleSheet = {
  listItem: {},
  listItemButton: {
    height: '48px', boxSizing: 'border-box',
    borderLeftWidth: 6,
    borderLeftStyle: 'solid',
    borderLeftColor: 'common.transparent',
  },
  listItemIcon: { minWidth: '24px', mr: 2 },
};


function SidebarItem(props) {
  const { label, icon, component, slotProps, ...restProps } = props;
  const { listItem: listItemProps = {}, listItemButton: listItemButtonProps = {} } = slotProps || {};

  const { isCollapsed } = useSidebar();

  const Wrapper = isCollapsed
    ? { Component: Tooltip, props: { arrow: true, placement: 'right', title: label } }
    : { Component: Fragment, props: {} };


  return (
    <Wrapper.Component {...Wrapper.props}>
      <ListItem disablePadding sx={[StyleSheet.listItem, listItemProps.sx]}>
        <ListItemButton
          component={component}
          sx={[StyleSheet.listItemButton, listItemButtonProps.sx]}
          {...restProps}
        >
          <ListItemIcon sx={StyleSheet.listItemIcon}>{icon}</ListItemIcon>

          {!isCollapsed
            ? (
              <ListItemText primary={label} primaryTypographyProps={{ noWrap: true }} />
            )
            : null}
        </ListItemButton>
      </ListItem>
    </Wrapper.Component >

  );
}

SidebarItem.displayName = 'SidebarItem';
export default SidebarItem;
